import { createAction, props } from '@ngrx/store';
import { MspHaloMapping } from './model';

export const loadMspHaloMappings = createAction('[MSP Halo] Load Mappings');
export const loadMspHaloMappingsSuccess = createAction(
    '[MSP Halo] Load Mappings Success',
    props<{ items: MspHaloMapping[] }>(),
);
export const loadMspHaloMappingsFailure = createAction('[MSP Halo] Load Mappings Failure', props<{ error: any }>());

export const updateMspHaloMappings = createAction('[MSP Halo] Update Mappings', props<{ items: MspHaloMapping[] }>());
export const updateMspHaloMappingsSuccess = createAction(
    '[MSP Halo] Update Mappings Success',
    props<{ items: MspHaloMapping[] }>(),
);
export const updateMspHaloMappingsFailure = createAction('[MSP Halo] Update Mappings Failure', props<{ error: any }>());
